import StorageIcon from '@mui/icons-material/Storage';
import { Box, TableCell } from '@mui/material';
import PropTypes from 'prop-types';

import { formatBytes, sentenceCase } from '../../../../utils/utils';
import Text from '../../../elements/text/Text';

const TypeCell = ({ category, size }) => {
  return (
    <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
      <Text body>{sentenceCase(category)}</Text>
      {size && (
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            px: 0.5,
            border: '1px solid grey',
            borderRadius: '3px',
          }}
        >
          <StorageIcon fontSize="small" />
          <Text caption sx={{ marginLeft: '0.5em', cursor: 'default' }}>
            {!isNaN(size) ? formatBytes(size) : '-'}
          </Text>
        </Box>
      )}
    </TableCell>
  );
};

TypeCell.propTypes = {
  category: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default TypeCell;
